import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Page, formatBRL, Empty } from "./_shared";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ShoppingCart } from "lucide-react";

export default function Recommendations() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/recommendations").then((r) => setData(r.data)); }, []);

  if (!data) return <Skeleton className="h-96" />;

  return (
    <Page title="Recomendações de compra" subtitle="O que comprar agora para evitar rupturas e atender à demanda projetada.">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <KPI label="Total a investir" value={formatBRL(data.total_investment)} accent />
        <KPI label="Itens recomendados" value={data.recommendations.length} />
        <KPI label="Receita potencial" value={formatBRL(data.recommendations.reduce((a, r) => a + r.suggested_purchase * r.price, 0))} />
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden mt-6">
        {data.recommendations.length === 0 ? (
          <div className="p-10"><Empty title="Sem compras urgentes" desc="Sua operação está abastecida." /></div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="border-border hover:bg-transparent">
                <TableHead>Produto</TableHead>
                <TableHead>Categoria</TableHead>
                <TableHead className="text-right">Estoque</TableHead>
                <TableHead className="text-right">Demanda 30d</TableHead>
                <TableHead className="text-right">Comprar</TableHead>
                <TableHead className="text-right">Investimento</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.recommendations.map((r) => (
                <TableRow key={r.product_id} data-testid={`row-${r.product_id}`} className="border-border">
                  <TableCell className="font-medium">{r.name}</TableCell>
                  <TableCell className="text-muted-foreground">{r.category}</TableCell>
                  <TableCell className="text-right">{r.stock}</TableCell>
                  <TableCell className="text-right">{r.expected_demand_30d}</TableCell>
                  <TableCell className="text-right">
                    <span className="px-2 py-0.5 rounded-md bg-primary/15 text-primary border border-primary/30 font-mono text-sm">{r.suggested_purchase}</span>
                  </TableCell>
                  <TableCell className="text-right font-mono">{formatBRL(r.suggested_purchase * r.cost)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </Page>
  );
}

const KPI = ({ label, value, accent }) => (
  <div className={`p-6 rounded-xl border bg-card ${accent ? "border-primary/40 glow-coral" : "border-border"}`}>
    <div className="text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-2">
      <ShoppingCart className="w-3.5 h-3.5" /> {label}
    </div>
    <div className={`font-display text-3xl font-bold mt-3 ${accent ? "text-primary" : ""}`}>{value}</div>
  </div>
);
